import React, { FC } from 'react';
import * as S from './FiltersDrawer.styles';
import { Property, PropertyOption } from '@/api/types/categories.types';
import { Collection } from '@/components/Filters/FiltersDrawer.types';

type Props = {
  propertyLegacyId?: string;
  options?: PropertyOption[];
  collection?: Collection;
  allProperties?: Property[];
  onOptionSelect?: (option: PropertyOption) => void;
};

export const CollectionChips: FC<Props> = ({
  propertyLegacyId,
  options,
  collection,
  allProperties,
  onOptionSelect,
}) => {
  const name = allProperties?.find(
    el => el.legacyResourceId === propertyLegacyId
  )?.name;

  function handleOptionSelect(value: PropertyOption) {
    if (onOptionSelect) {
      onOptionSelect(value);
    }
  }

  return (
    <S.FieldWithTitleWrapper $hasPadding>
      <S.FieldTitle>{name}</S.FieldTitle>
      <S.ChipsContainer>
        {options?.map(option => {
          const isSelected =
            option.legacyResourceId.toString() ===
            collection?.[option.propertyLegacyId];
          return (
            <S.Chip
              key={option.name}
              appearance={isSelected ? 'primary' : 'gray'}
              isRounded
              onClick={() => handleOptionSelect(option)}
            >
              {option.name}
            </S.Chip>
          );
        })}
      </S.ChipsContainer>
    </S.FieldWithTitleWrapper>
  );
};

CollectionChips.displayName = 'CollectionChips';
